import store from '@/store';
import snq from 'snq';
// Lines Helper
export const linesHelper = {
  getActiveMenu: getActiveMenu,
  menuIsVisible: menuIsVisible,
  menuHaveChanges: menuHaveChanges,
  getAllLeagueIds: getAllLeagueIds,
  getMenuByLeagueId: getMenuByLeagueId,
};

function setLiveMenuLeagueIds(menu) {
  let leagueIds = '';
  menu.children.map((item) => {
    // featured
    item.children.map((subItem) => {
      // tabs
      subItem.children.map((league) => {
        //leagues
        leagueIds += league.league_id + ',';
      });
    });
  });

  return leagueIds.endsWith(',') ? leagueIds.slice(0, -1) : leagueIds;
}

function checkMenuSet(menu) {
  return store.state.sportMenu.activeMenu.id === menu.id;
}

// Get Active Menu, Nav and LeagueIds in Menu List by URLl
function getActiveMenu(url, menuList) {
  let activeLeagues = '';
  var BreakException = {};
  const _menuList = [...menuList];
  try {
    // SportTypes
    _menuList
      .reverse()
      .filter((item) => item.url)
      .forEach((menu) => {
        // menu.children[0].children = []; // <---------------- development purpose

        if ('/' + menu.url.split('/').slice(2).join('/') === url) {
          store.commit('sportMenu/setActiveMenu', menu);
          const firstFeatured = snq(() => menu.children[0].children[0]);
          const firstCountry = snq(() => menu.children[1].children[0]);
          if (firstFeatured) {
            store.dispatch('sportMenu/setActiveNav', firstFeatured);
          } else if (firstCountry) {
            store.dispatch('sportMenu/setActiveNav', firstCountry);
          }

          if (menu.icon === 'live') {
            activeLeagues = setLiveMenuLeagueIds(menu);
            throw BreakException;
          } else if (!menu.league_id) {
            const firstCat = snq(() => menu.children[1].children[0].children[0].league_id);
            const firstLeague = snq(() => menu.children[0].children[0].league_id);
            if (firstLeague) {
              activeLeagues = firstLeague;
            } else if (firstCat) {
              store.commit(
                'sportMenu/setActiveCountry',
                snq(() => menu.children[1].children[0].id),
              );
              activeLeagues = snq(() => menu.children[1].children[0].children.map((c) => c.league_id).join(','));
            }
            throw BreakException;
          }
        }
        // SubCategory Feature or Countries
        menu.children
          .forEach((category) => {
            if (category.url) {
              if ('/' + category.url.split('/').slice(2).join('/') === url) {
                store.commit('sportMenu/setActiveMenu', menu);
                store.dispatch('sportMenu/setActiveNav', category);
              }
            }
            // Featured Leagues & Countries
            category.children
              .forEach((league) => {
                if (league.url) {
                  if ('/' + league.url.split('/').slice(2).join('/') === url) {
                    store.commit('sportMenu/setActiveMenu', menu);
                    store.commit('sportMenu/setActiveCountry', league.id);
                    store.dispatch('sportMenu/setActiveNav', league);
                    if (!league.league_id && league.type === 'group') {
                      let leagueIds = '';
                      league.children.map((i) => {
                        leagueIds += i.league_id + ',';
                      });
                      leagueIds = leagueIds.endsWith(',') ? leagueIds.slice(0, -1) : leagueIds;
                      activeLeagues = leagueIds;
                      throw BreakException;
                    } else {
                      activeLeagues = league.league_id;
                      throw BreakException;
                    }
                  } else if (league.type === 'group') {
                    // Countries
                    if (league.children) {
                      league.children
                        .forEach((i) => {
                          if (i.url) {
                            if ('/' + i.url.split('/').slice(2).join('/') === url) {
                              store.commit('sportMenu/setActiveMenu', menu);
                              store.dispatch('sportMenu/setActiveNav', i);
                              store.commit('sportMenu/setActiveCountry', league.id);
                              activeLeagues = i.league_id;
                              throw BreakException;
                            }
                          }
                        });
                    }

                  }
                }

              });
          });
      });
  } catch (e) {
    if (e !== BreakException) throw e;
  }
  // debugger;
  return activeLeagues;
}

export function menuIsVisible(list, menuId) {
  return list.some((item) => {
    if (!item.visible) {
      return false;
    } else if (item.id == menuId) {
      return true;
    } else if (item.children) {
      return menuIsVisible(item.children, menuId);
    } else {
      return false;
    }
  });
}

export function menuHaveChanges(list, activeMenu) {
  return list.some((item) => {
    if (item.id == activeMenu.id) {
      if (JSON.stringify(item) != JSON.stringify(activeMenu)) {
        activeMenu = Object.assign(activeMenu, item);
        return true;
      } else {
        activeMenu = Object.assign(activeMenu, item);
        return false;
      }
    } else if (item.children) {
      return menuHaveChanges(item.children, activeMenu);
    } else {
      return false;
    }
  });
}

export function getAllLeagueIds(list, activeNav) {
  const loopFinder = (list, menuId, callback) => {
    return list.find((item) => {
      if (!item.visible) {
        return false;
      } else if (item.id == menuId) {
        callback(item);
        return true;
      } else if (item.children) {
        return loopFinder(item.children, menuId, callback);
      } else {
        return false;
      }
    });
  };
  const loopLeagueIdSetter = (menu, callback) => {
    if (menu.league_id) {
      callback(menu.league_id);
    }
    if (menu.children) {
      menu.children.forEach((item) => {
        loopLeagueIdSetter(item, callback);
      });
    }
  };
  let leagueIds = [];
  loopFinder(list, activeNav.id, (item) => {
    activeNav = Object.assign(activeNav, item);
    loopLeagueIdSetter(item, (leagueId) => {
      leagueIds.push(leagueId);
    });
  });

  return leagueIds.join(',');
}

function findInMenu(list, leagueId) {
  return list.find((item) => {
    if (item.type === 'group' && item.icon !== 'all-sport') {
      return findInMenu(item.children, leagueId);
    }
    return item.league_id == leagueId;
  });
}

export function getMenuByLeagueId(leagueId) {
  return findInMenu(store.state.sportMenu.menuList, leagueId);
}
